import { ObjectId } from "bson";
import { MongoHelper } from "../helpers/mongo-helper";
import { AbstractObject } from "./abstract-object";
import { LocalDateTime } from "./local-date-time/local-date-time";

/**
 * A adatosztályok ősobjektuma.
 * Tartalmazza a kötelező mezők definícióit és a származtatott osztályokban
 * használható közös függvényeket, tulajdonságokat.
 */
export abstract class AbstractModel extends AbstractObject {
    /************************ */
    /** Administrative fields */
    /************************ */
    /** Az objektum egyedi azonosítója. DB-ben generált értéket kaphat csak. */
    _id?: ObjectId;
    /**
     * Az objektum tárolási sorrendje. Minden tárolásko értéke egyel nő.
     * Ennek segítségével lehet a detektálni, hogy az adott objektum módosult-e azóta,
     * hogy le lett kérdezve az adatbázisból.
     * Értéke nagyobb, mint 0.
     */
    seq?: number;
    /** Az objektumot létrehozó felhasználó felhasználóneve. */
    creator?: String;
    /** Az objektum létrehozásának időpontja. */
    createdAt?: LocalDateTime;
    /** Az objektumot legutoljára módosító felhasználó felhasználóneve. */
    modifier?: string;
    /** Az objektum legutolsó módosításának időpontja. */
    modifiedAt?: LocalDateTime;
    /**
     * Jelzi, hogy az adott objektum aktív-e az azt kezelő folyamat szempontjából.
     * Ha a folymat szempontjából nem értelmezhető, akkor értéke mindig 'true'.
     */
    active?: boolean = true;

    /**
     * Az _id hexadecimális értéke stringként.
     * Csak akkor érhető el, ha 'new'-val példányosított az osztály, egyébként null!
     */
    public id?: string;

    /**
     * Inicializálja az objektumot (belemásolja a paraméterben megadott adatstruktúra értékeit).
     * Minden származtatott osztály konstruktorában szerepelnie kell!
     * Csak akkor érhető el, ha 'new'-val példányosított az osztály.
     */
    protected init?(data: any, target: AbstractModel): void {
        delete this.id;
        if (data) {
            super.init(data, target);

            delete this.id; // Töröljük itt is, hogy biztosan csak akkor kapjon értéket, ha van az _id-nak is értéke.
            if (this._id) {
                // console.log("INIT "); console.log(data._id);
                this._id = MongoHelper.toObjectId(this._id);
                this.id = this._id.toHexString();
            }

            if (this.createdAt) {
                this.createdAt = new LocalDateTime(this.createdAt);
            }
            if (this.modifiedAt) {
                this.modifiedAt = new LocalDateTime(this.modifiedAt);
            }
        }
    }
}